import { BulkSpreadsheet, parseBool, type BulkColumn } from '../shared/BulkSpreadsheet';
import { userApiService } from '@kss/api';
import type { ApiUserCreate } from '@kss/api';
import { loadRoleOptions } from '../shared/formLoaders';

const columns: BulkColumn<ApiUserCreate>[] = [
  { key: 'name', header: 'Name', required: true, sample: 'Jane Doe' },
  { key: 'email', header: 'Email', required: true, sample: 'jane@company.com' },
  { key: 'phone', header: 'Phone', sample: '+91...' },
  { key: 'role', header: 'Role', dataType: 'lookup', loadOptions: loadRoleOptions, sample: 'staff' },
  { key: 'isActive', header: 'Active', dataType: 'boolean', parse: parseBool as never, sample: 'true' },
];

export default function BulkUser() {
  return (
    <BulkSpreadsheet<ApiUserCreate> title="Bulk import users" entityLabel="user" backPath="/panel/users" columns={columns} module="User"
      onImport={async (rows) => {
        const payload = rows.map((r) => ({ ...r, isActive: r.isActive ?? true }));
        const created = await userApiService.create(payload);
        return { created: Array.isArray(created) ? created.length : payload.length };
      }}
    />
  );
}
